import { useSession } from '@/hooks/useSession';
import { QUOTE_PERMISSIONS } from '../permissions';

type QuotePermission = (typeof QUOTE_PERMISSIONS)[keyof typeof QUOTE_PERMISSIONS];

const PERMISSION_BYPASS_ROLES = new Set(['full_admin', 'director']);

export function useHasQuotePermission(permission: QuotePermission): boolean {
  const { user } = useSession();
  if (!user) return false;
  if (user.postgres_roles.some((role) => PERMISSION_BYPASS_ROLES.has(role))) {
    return true;
  }
  return user.permission_strings?.includes(permission) ?? false;
}
